import styled from '@emotion/styled';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_SECONDARY};
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const ControlsContainer = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: center;
  gap: 10px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 24px;
`;

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const HeaderButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:hover {
    background-color: ${props => props.disabled ? 'white' : COLORS.PRIMARY};
    color: ${props => props.disabled ? COLORS.PRIMARY : 'white'};
  }
`;

// Meeting Card Styles (MeetingCardsGrid used by MyMeetings component)
export const MeetingCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 24px;
  padding: 8px 0;
`;

export const MeetingCard = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const AttendeesInfo = styled.div`
  display: flex;
  align-items: center;
  gap: -8px;
`;

export const AvatarGroup = styled.div`
  display: flex;
  align-items: center;
  margin-right: 12px;

  & > * {
    margin-left: -8px;
    border: 2px solid white;
    border-radius: 50%;
  }

  & > *:first-of-type {
    margin-left: 0;
  }
`;

export const MoreAttendeesChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e5e7eb;
  color: #374151;
  font-size: 11px;
  font-weight: 600;
  margin-left: -8px;
  border: 2px solid white;
`;

export const AttendeeNames = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PrimaryAttendeeName = styled.span`
  font-weight: 600;
  color: #1a1a1a;
  font-size: 14px;
`;

export const SecondaryAttendeeText = styled.span`
  color: #6b7280;
  font-size: 12px;
`;

export const MeetingSubject = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const MeetingDescription = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const TypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.$bgColor || '#f3f4f6'};
  color: ${props => props.$color || '#374151'};
  border: 1px solid ${props => props.$borderColor || '#e5e7eb'};
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.$bgColor || '#f3f4f6'};
  color: ${props => props.$color || '#374151'};
  border: 1px solid ${props => props.$color ? `${props.$color}50` : '#e5e7eb'};
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
`;

export const DateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${props => props.$overdue ? '#dc2626' : '#6b7280'};
  font-size: 13px;
  font-weight: ${props => props.$overdue ? '500' : 'normal'};
`;

export const CountsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #6b7280;
`;

export const CountItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

// Form styles
export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
`;

export const FormTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  background: white;
  padding: 0 24px;
`;

export const Tab = styled.button`
  padding: 12px 16px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.$active ? COLORS.PRIMARY : '#6b7280'};
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background-color: ${props => props.$active ? COLORS.PRIMARY : 'transparent'};
  }

  &:hover {
    color: ${COLORS.PRIMARY};
  }
`;

export const TabBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin-left: 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${props => props.$active ? COLORS.PRIMARY : '#e5e7eb'};
  color: ${props => props.$active ? 'white' : '#6b7280'};
`;

export const FormContent = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`;

export const SavingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
`;

// Talking Points styles
export const TalkingPointsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TalkingPointItem = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const TalkingPointNumber = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${COLORS.PRIMARY};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const TalkingPointContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TalkingPointQuestion = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const TalkingPointNotes = styled.div`
  font-size: 13px;
  color: #6b7280;
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
`;

// Previous Meetings styles
export const PreviousMeetingsContainer = styled.div`
  display: flex;
  height: 100%;
  gap: 24px;
`;

export const PreviousMeetingsList = styled.div`
  width: 280px;
  border-right: 1px solid #e5e7eb;
  padding-right: 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PreviousMeetingItem = styled.div`
  padding: 12px;
  background-color: ${props => props.$selected ? '#f0f9ff' : '#f8f9fa'};
  border: 1px solid ${props => props.$selected ? '#0ea5e9' : '#e0e0e0'};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.$selected ? '#f0f9ff' : '#f1f3f5'};
    border-color: ${props => props.$selected ? '#0ea5e9' : '#bdbdbd'};
  }
`;

export const PreviousMeetingDate = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
`;

export const PreviousMeetingSubject = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const PreviousMeetingDetails = styled.div`
  flex: 1;
  overflow-y: auto;
`;

// Notes styles
export const NotesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const NoteItem = styled.div`
  padding: 16px;
  background-color: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
`;

export const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const NoteAuthor = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #92400e;
`;

export const NoteDate = styled.span`
  font-size: 11px;
  color: #a16207;
`;

export const NoteContent = styled.div`
  font-size: 14px;
  color: #78350f;
  line-height: 1.5;
  white-space: pre-wrap;
`;

// Action Items styles
export const ActionItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ActionItemCard = styled.div`
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  border-left: 4px solid ${props => {
    switch (props.$priority) {
      case 'High': return '#dc2626';
      case 'Medium': return '#f59e0b';
      case 'Low': return '#22c55e';
      default: return '#6b7280';
    }
  }};
`;

export const ActionItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const ActionItemTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const ActionItemStatus = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background-color: ${props => {
    switch (props.$status) {
      case 'Done': return '#dcfce7';
      case 'InProgress': return '#fef3c7';
      case 'Cancelled': return '#fef2f2';
      default: return '#f3f4f6';
    }
  }};
  color: ${props => {
    switch (props.$status) {
      case 'Done': return '#166534';
      case 'InProgress': return '#92400e';
      case 'Cancelled': return '#dc2626';
      default: return '#374151';
    }
  }};
`;

export const ActionItemMeta = styled.div`
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #6b7280;
`;
